import React from 'react';
import Button from '../../../../../components/Basic/Button';
import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import ActiveStrategy from './ActiveStrategy';
import { useDispatch, useSelector } from 'react-redux';
import { getSignalsListCached } from '../../../../../stores/signals-main/signals/getters';
import SourceImage from '../../../SourceImage';
import { fetchSignalsList } from '../../../../../stores/signals-main/signals/actions';
import { addNotification } from '../../../../../actions/notifications';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    height: '100%',
    fontSize: '0.85rem',
    fontWeight: 600,
    color: 'var(--color-fontColors-grey-1)',
    backgroundColor: 'var(--color-backgroundColors-hoverRowAlt)',
    border: '1px solid var(--color-border-grey)',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    padding: '0 8px',
    flex: 1,

    // eslint-disable-next-line no-useless-computed-key
    ['@media (min-width: 1100px)']: {
      minWidth: 263,
      flex: 'initial',
    },

    '& > span': {
      '&:first-child': {
        display: 'flex',
        height: '100%',
      },
    },

    // eslint-disable-next-line no-useless-computed-key
    ['@media (min-width: 1300px)']: {
      fontSize: '0.93rem',
    },

    '&.active': {
      color: 'var(--color-colorPrimary-main)',
      backgroundColor: 'var(--color-white)',
      borderBottomColor: 'var(--color-white)',
    },

    '& .tab-item-internal': {
      display: 'flex',
      padding: 6,
      paddingLeft: 10,
      paddingRight: 10,
      height: '100%',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',

      // eslint-disable-next-line no-useless-computed-key
      ['@media (min-width: 1300px)']: {
        paddingLeft: 6,
        paddingRight: 6,
      },
    },
  },
}));

export function getActiveSignalsTableTab() {
  const params = new URLSearchParams(document.location.search);
  const tab = params.get('tab');

  return tab || 'tv';
}

export function useActiveSignalsTableTab() {
  return getActiveSignalsTableTab();
}

function TabItem({ value, label }) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const activeTab = useActiveSignalsTableTab();
  const activeNoTv = useSelector((state) => {
    const filter = getSignalsListCached(state)?.filter(
      (item) =>
        item.enabled &&
        (item.type === 'tv_indicator' || item.type === 'tv_strategy')
    );

    return filter.length;
  });
  const activeNoCustom = useSelector((state) => {
    const filter = getSignalsListCached(state)?.filter(
      (item) => item.enabled && item.type === 'custom'
    );

    return filter.length;
  });

  async function onClick() {
    try {
      history.push(`?tab=${value}`);

      await dispatch(fetchSignalsList(value));
    } catch (e) {
      dispatch(
        addNotification({
          type: 'error',
          message: 'Failed to fetch Signals',
        })
      );
    }
  }

  return (
    <Button
      data-id={value}
      className={`${classes.root} ${value === activeTab ? 'active' : ''}`}
      onClick={onClick}
    >
      <div className="tab-item-internal">
        <SourceImage value={value} />
        <div className="tab-item-main-details">{label}</div>
        {value === 'tv' ? (
          <ActiveStrategy
            show={activeNoTv ? true : false}
            activeNo={activeNoTv}
          />
        ) : (
          ''
        )}

        {value === 'custom' ? (
          <ActiveStrategy
            show={activeNoCustom ? true : false}
            activeNo={activeNoCustom}
          />
        ) : (
          ''
        )}
      </div>
    </Button>
  );
}

export default TabItem;
